import { StatusBadge } from "@/shared/ui";
import { mesOpStatusLabel } from "@/modules/mes/components/mesOpLabels";

/** Field operation status — same tone as Ops `StatusBadge`, short VI label. */
export function MesOpStatusBadge({ status }: { status: string }) {
  return <StatusBadge status={status} label={mesOpStatusLabel(status)} />;
}

/** Filter options using Field op shorten labels. */
export function mesOpFilterOptions(
  values: readonly string[],
): Array<{ value: string; label: string }> {
  return values.map((value) => ({ value, label: mesOpStatusLabel(value) }));
}
